<template>
  <div class="container">
    <van-nav-bar title="收银台" left-arrow @click-left="onClickLeft"></van-nav-bar>
    <div class="cashier-money">
      ¥{{ payMoney }}
    </div>
    <div class="coupon-main">
      <div class="coupon-txt"></div>
      <van-radio-group v-model="selectCouponId" class="coupon-list">
        <van-cell-group>
          <van-cell
            clickable
            @click="selectCoupon(item)"
            v-for="(item, index) in usableCoupons"
            :key="index"
          >
            <template slot="title">
              <span class="coupon-title">{{ item.typeStr }}</span>
              <span class="coupon-title">{{ item.cardName }}</span>
              <span class="custom-money">{{ item.amountStr }}</span>
            </template>
            <van-radio slot="right-icon" :name="item.couponId"></van-radio>
          </van-cell>
        </van-cell-group>
      </van-radio-group>
      <van-cell-group class="total-money">
        <van-cell title="总金额" :value="totalMoney"></van-cell>
        <van-cell title="优惠劵减免" :value="couponMoney" v-if="couponMoney"></van-cell>
      </van-cell-group>
      <div class="bottom-bar-placeholder"></div>
      <div class="bottom-bar" @click="payInfo">
        <div class="button-default " :class="isApp === 'isWeixin' ? 'wx-button-primary' : 'zfb-button-primary'">付款 ¥ {{ payMoney }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import WXPay from '../../util/wxpay'
export default {
  name: "cashier",
  data() {
    return {
      selectCouponId: "",
      totalMoney: 0, // 总金额
      couponMoney: "",
      orderNo: '',
      usableCoupons: '',
      usableCards: '',
      coupons: [],
    };
  },
  computed: {
    ...mapState(['isApp', 'openId']),
    payMoney() {
      return this.couponMoney > this.totalMoney ? '0.00' : this.totalMoney - this.couponMoney
    }
  },
  mounted () {
    let query = this.$route.query
    const { totalMoney = 0 } = query
    this.totalMoney = totalMoney
    this.offerPay()
  },
  methods: {
    offerPay () {
      this.$api.pay.offerPayApi({
        amount: this.totalMoney * 100
      }).then(res => {
        console.log(res);
        if (res.errCode === '0') {
          const { orderNo = '', discountStr = '', usableCards = [], usableCoupons = [] } = res.data
          this.orderNo = orderNo
          this.usableCoupons = usableCoupons
          this.couponMoney = discountStr
          this.usableCards = usableCards
          usableCoupons.forEach(item => {
            if (item.select) {
              this.selectCouponId = item.couponId
            }
          })
        }
      });
    },
    payInfo () {
      const { orderNo, openId = '' } = this
      let payChancel
      if (this.isApp === 'isAlipay') {
        payChancel = 2
      } else if (this.isApp === 'isWeixin') {
        payChancel = 1
      }
      this.$api.pay.payInfoApi({
        orderNo,
        payChancel,
        openId
      }).then(res => {
        console.log(res);
        if (res.errCode === '0') {
          const { payType } = res.data
          console.log('payInfoApi', res.data)
          if (payType === 'wxPay') { // 微信支付
            console.log('isApp', this.isApp)
            if (this.isApp === 'isAlipay') {
              this.aliPay(res.data)
            } else if (this.isApp === 'isWeixin') {
              this.callWXPay(res.data)
            }
            // this.callWXPay(res.data)
          } else if (payType === 'cardPay') {
          
          } else if (payType === 'couponPay') {
  
          }
        }
      });
    },
    aliPay (obj) {
      ap.tradePay({
        tradeNO: obj.aliTradeNo
      }, (res) => {
        console.log('aliPay', res)
        // ap.alert(res.resultCode);
        if (res.resultCode === '9000') {
          this.paySuccess()
        }
      });
    },
    callWXPay (obj) {
      function payCallback(payResult) {
        // 客户端，支付成功
        if (payResult === 'ok') {
          console.log('支付成功')
          this.paySuccess()
          // 客户端，用户取消
        } else if (payResult === 'cancel') {
          console.log('支付失败')
          // do nothing
          // 客户端，其他错误导致支付失败
        } else {
          this.$toast('支付失败，请稍后重试')
        }
      }
      WXPay.callWXPay(obj, payCallback.bind(this))
    },
    // wxPay (obj) {
    //   wx.chooseWXPay({
    //     timestamp: obj.timeStamp,
    //     nonceStr: obj.nonceStr,
    //     package: obj.packageStr,
    //     signType: obj.signType,
    //     paySign: obj.paySign,
    //     success: (res) => {
    //       this.paySuccess()
    //     },
    //     fail: () => {
    //     },
    //     complete: () => {
    //     },
    //     cancel: () => {
    //     }
    //   })
    // },
    paySuccess () {
      this.$router.push({ path: '/commentSuccess' })
    },
    selectCoupon(item) {
      this.couponMoney = item.amountStr
      this.selectCouponId = item.couponId
    },
    onClickLeft() {
      this.$router.go(-1)
    }
  }
};
</script>

<style scoped lang="stylus">
.container
  min-height 100vh
  background-size cover
  .cashier-money
    padding 65px 0
    font-size 36px
    font-weight bold
    text-align center
  .coupon-main
    width 90vw
    margin 0 auto
    .coupon-list
      overflow hidden
      border-radius 8px
      background #fff
      box-shadow 0 5px 9px 0 rgba(0,0,0,0.04);
    .total-money
      margin-top 30px
      overflow hidden
      border-radius 8px
      background #fff
      box-shadow 0 5px 9px 0 rgba(0,0,0,0.04)
</style>
